// api.js
import axios from "axios";
import { clearSession } from "../utilities/session";

const DEFAULT_API_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.iconicunitygroup.com"
    : "http://localhost:8000";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || DEFAULT_API_URL, // backend root
  withCredentials: true, // cookie send with request
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    // null হলে header পুরোটা সরিয়ে দাও
    delete config.headers.Authorization;
  }
  return config;
});

// Auth endpoints whose own 401/403 responses are handled by the calling page.
const AUTH_REQUEST_PATTERN = /(^|\/)api\/(login|register|auth\/google|google|otp|verify-otp|send-otp|forgot-password|reset-password)/i;

const isAuthRequest = (config) => AUTH_REQUEST_PATTERN.test(config?.url || "");

const forceLogout = () => {
  clearSession();
  // Login only honors ?redirect= for /sso/authorize, so a plain redirect is used.
  if (window.location.pathname !== "/login") {
    window.location.assign("/login");
  }
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const config = error.config;
    if (status && !isAuthRequest(config)) {
      const message = String(error.response?.data?.message || "").toLowerCase();
      if (status === 401) {
        forceLogout();
      } else if (status === 403 && /inactive|deactivated|disabled/.test(message)) {
        forceLogout();
      }
    }
    return Promise.reject(error);
  }
);

export default api;
